import { ErrorBoundary } from "$components/error-boundary";
import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { RequireAuth } from "$routes/_lib/require-auth";
import { Role } from "elephant-web/gql";
import { Navigate, Route, Routes } from "react-router-dom";
import AddItemsPage from "./[:id]/add-prices/page";
import { PriceListBulkImportPage } from "./[:id]/bulk-import/page";
import CreateCustomItemsPage from "./[:id]/create-custom-items/page";
import PriceListPage from "./[:id]/page";
import CreatePriceListPage from "./create/page";
import { Root } from "./page";

const PRICE_LIST_ROLES = [Role.Admin, Role.Clinic, Role.Elephant];
const ADD_ITEMS_ROLES = [Role.Admin, Role.Clinic, Role.Elephant];

const BulkImportRoute = () => {
  const [bulkUploadFlag, { loading }] = useFeatureFlag(
    featureFlags.billing.priceListBulkUpload,
  );
  if (loading) {
    return null;
  }
  if (!bulkUploadFlag) {
    return <Navigate to=".." replace />;
  }
  return <PriceListBulkImportPage />;
};

export const PriceListRoutes = () => (
  <ErrorBoundary name="price-list">
    <Routes>
      <Route path="*">
        <Route
          index
          element={
            <RequireAuth only={PRICE_LIST_ROLES}>
              <Root />
            </RequireAuth>
          }
        />
        <Route
          path="create"
          element={
            <RequireAuth only={PRICE_LIST_ROLES}>
              <CreatePriceListPage />
            </RequireAuth>
          }
        />
        <Route path=":id">
          <Route
            index
            element={
              <RequireAuth only={PRICE_LIST_ROLES}>
                <PriceListPage />
              </RequireAuth>
            }
          />
          <Route
            path="add-prices"
            element={
              <RequireAuth only={ADD_ITEMS_ROLES}>
                <AddItemsPage />
              </RequireAuth>
            }
          />
          <Route
            path="create-custom-items"
            element={
              <RequireAuth only={ADD_ITEMS_ROLES}>
                <CreateCustomItemsPage />
              </RequireAuth>
            }
          />
          <Route
            path="bulk-import"
            element={
              <RequireAuth only={ADD_ITEMS_ROLES}>
                <BulkImportRoute />
              </RequireAuth>
            }
          />
        </Route>
      </Route>
    </Routes>
  </ErrorBoundary>
);
